import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { UnderPaidAgingIncomingInvoiceTodoFormProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { DateInputProps, RadioGroupProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { AgingIncomingInvoiceUnderPaidActions } from "models/enums/incomingInvoice";
//#endregion
//#region components
import {
  DateInput,
  GroupSection,
  RadioGroup,
  TextInput,
  useWintForm,
  VerticalFormField,
  WintForm,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const UnderPaidAgingIncomingInvoiceTodoForm: ForwardRefRenderFunction<
  FormHandles,
  UnderPaidAgingIncomingInvoiceTodoFormProps
> = (props, ref) => {
  const { wintFormProps, connect, values } = useWintForm<IncomingInvoiceFormTypes.UnderPaidAgingInvoiceTodo>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    handleSubmit: props.handleSubmit,
    enableReinitialize: true,
  });

  const hidePaymentCreation = props.invoice?.disablePaymentCreation ?? false;

  const underPaidChoices = EnumHelper.getNumericItemValues(AgingIncomingInvoiceUnderPaidActions)
    .filter((key) => !hidePaymentCreation || key !== AgingIncomingInvoiceUnderPaidActions.UnderpaidCreatePayment)
    .map((key) => ({
      id: key,
      value: LocalizationHelperInstance.getTranslatedEnumValue("IncomingInvoice.AgingUnderPaidTodoAction", key),
    }));

  return (
    <WintForm {...wintFormProps}>
      <Grid container className={cssExports.sectionedForm} marginBottom={-2.5}>
        <VerticalFormField<RadioGroupProps> Component={RadioGroup} {...connect("action")} items={underPaidChoices} />
        {values.action === AgingIncomingInvoiceUnderPaidActions.UnderpaidHasBeenPaidInfoSupplied && (
          <VerticalFormField<DateInputProps>
            Component={DateInput}
            {...connect("paymentDate")}
            label={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.IncomingInvoice.AgingPaymentDateLabel
            )}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.IncomingInvoice.AgingPaymentDateHelpText
            )}
          />
        )}
        {(values.action === AgingIncomingInvoiceUnderPaidActions.UnderpaidHasBeenPaidInfoSupplied ||
          values.action === AgingIncomingInvoiceUnderPaidActions.UnderpaidOtherInfoSupplied) && (
          <VerticalFormField<TextInputProps>
            Component={TextInput}
            {...connect("explanation")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.AgingOtherInfoLabel)}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.IncomingInvoice.AgingOtherInfoHelpText
            )}
          />
        )}
        {values.action === AgingIncomingInvoiceUnderPaidActions.UnderpaidCreatePayment && (
          <>
            <VerticalFormField<DateInputProps>
              Component={DateInput}
              {...connect("plannedPaymentDate")}
              label={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.IncomingInvoice.AgingPlannedDateLabel
              )}
            />
            <GroupSection
              header=""
              description={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentInformation)}
              className={cssExports.noBorder}
            >
              <VerticalFormField<TextInputProps>
                Component={TextInput}
                {...connect("paymentNumber")}
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PG_BG)}
                disabled
              />
            </GroupSection>
          </>
        )}
      </Grid>
    </WintForm>
  );
};

export default forwardRef(UnderPaidAgingIncomingInvoiceTodoForm);
